// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e0da5848","732":"4e341b10","977":"b9444b45"}[chunkId] + ".chunk.js";
};